(() => {
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const toast = $("[data-toast]");
  const money = (cents) => new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(cents / 100);
  let currentProduct = null;
  let currentImages = [];
  let currentImage = 0;
  let touchStart = null;

  function showToast(message) {
    if (!toast) return;
    toast.textContent = `${message} ✓`;
    toast.hidden = false;
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(() => { toast.hidden = true; }, 2400);
  }

  async function refreshCartCount() {
    const cart = await fetch("/cart.js").then((response) => response.json());
    const count = $("[data-cart-count]");
    if (count) {
      count.textContent = cart.item_count;
      count.dataset.count = cart.item_count;
    }
  }

  async function addVariant(id, redirect) {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    }).then((response) => {
      if (!response.ok) throw new Error("Unable to add this item");
      return response.json();
    });
    await refreshCartCount();
    if (redirect) window.location.href = redirect;
    else showToast("Added to your cart");
  }

  function applyFilter(category) {
    let visible = 0;
    $$("[data-category]").forEach((card) => {
      const show = category === "All products" || card.dataset.category === category;
      card.classList.toggle("is-hidden", !show);
      if (show) visible += 1;
    });
    $$("[data-filter]").forEach((button) => button.classList.toggle("active", button.dataset.filter === category));
    const count = $("[data-product-count]");
    if (count) count.textContent = `${visible} products`;
  }

  function setModalImage(index) {
    if (!currentImages.length) return;
    currentImage = (index + currentImages.length) % currentImages.length;
    const image = $("[data-modal-image]");
    image.classList.add("is-changing");
    clearTimeout(setModalImage.timer);
    setModalImage.timer = setTimeout(() => {
      image.src = currentImages[currentImage];
      requestAnimationFrame(() => image.classList.remove("is-changing"));
    }, 110);
    $$("[data-modal-thumbs] button").forEach((button, buttonIndex) => button.classList.toggle("active", buttonIndex === currentImage));
  }

  async function openProduct(handle, category) {
    const product = await fetch(`/products/${handle}.js`).then((response) => response.json());
    currentProduct = product;
    currentImages = product.images || [product.featured_image];
    currentImage = 0;
    $("[data-modal-title]").textContent = product.title;
    $("[data-modal-category]").textContent = category || "LumoNest favourite";
    $("[data-modal-price]").textContent = money(product.price);
    const compare = $("[data-modal-compare]");
    compare.textContent = product.compare_at_price > product.price ? money(product.compare_at_price) : "";
    $("[data-modal-description]").textContent = (product.description || "A joyful LumoNest find, chosen with care.").replace(/<[^>]*>/g, "").slice(0, 260);
    $("[data-modal-add]").dataset.variant = product.variants.find((variant) => variant.available)?.id || product.variants[0].id;
    const thumbs = $("[data-modal-thumbs]");
    thumbs.innerHTML = "";
    currentImages.forEach((image, index) => {
      const button = document.createElement("button");
      button.type = "button";
      button.innerHTML = `<img src="${image}" alt="">`;
      button.addEventListener("click", () => setModalImage(index));
      thumbs.appendChild(button);
    });
    setModalImage(0);
    $("[data-product-modal]").hidden = false;
    document.body.classList.add("modal-open");
    history.pushState({ lumonestModal: true }, "", location.href);
  }

  function closeProduct(fromBack = false) {
    const modal = $("[data-product-modal]");
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove("modal-open");
    if (!fromBack && history.state?.lumonestModal) history.back();
  }

  $("[data-menu-toggle]")?.addEventListener("click", () => $("[data-main-nav]")?.classList.toggle("is-open"));
  $$("[data-filter]").forEach((button) => button.addEventListener("click", () => applyFilter(button.dataset.filter)));
  $$("[data-filter-link]").forEach((link) => link.addEventListener("click", () => applyFilter(link.dataset.filterLink)));
  $$("[data-add-variant]").forEach((button) => button.addEventListener("click", () => addVariant(button.dataset.addVariant)));
  $$("[data-open-product]").forEach((button) => button.addEventListener("click", () => {
    window.location.href = `/products/${button.dataset.openProduct}`;
  }));
  $("[data-modal-close]")?.addEventListener("click", () => closeProduct());
  $("[data-product-modal]")?.addEventListener("click", (event) => { if (event.target === event.currentTarget) closeProduct(); });
  $("[data-gallery-prev]")?.addEventListener("click", () => setModalImage(currentImage - 1));
  $("[data-gallery-next]")?.addEventListener("click", () => setModalImage(currentImage + 1));
  $("[data-modal-image-wrap]")?.addEventListener("touchstart", (event) => { touchStart = event.touches[0].clientX; }, { passive: true });
  $("[data-modal-image-wrap]")?.addEventListener("touchend", (event) => {
    if (touchStart === null) return;
    const distance = event.changedTouches[0].clientX - touchStart;
    if (Math.abs(distance) > 45) setModalImage(currentImage + (distance < 0 ? 1 : -1));
    touchStart = null;
  }, { passive: true });
  $("[data-modal-add]")?.addEventListener("click", (event) => addVariant(event.currentTarget.dataset.variant));
  $("[data-modal-buy]")?.addEventListener("click", () => addVariant($("[data-modal-add]").dataset.variant, "/checkout"));
  window.addEventListener("popstate", () => closeProduct(true));
  refreshCartCount().catch(() => {});
})();


(function(){
  var storageKey='lumonest-wishlist';
  function readWishlist(){
    try { return JSON.parse(localStorage.getItem(storageKey)||'[]'); } catch(e) { return []; }
  }
  function saveWishlist(items){
    try { localStorage.setItem(storageKey,JSON.stringify(items)); } catch(e) {}
  }
  function notify(message){
    var toast=document.querySelector('[data-toast]');
    if(!toast) return;
    toast.textContent=message; toast.hidden=false;
    clearTimeout(window.lumoWishlistToast);
    window.lumoWishlistToast=setTimeout(function(){toast.hidden=true;},2200);
  }
  function renderWishlist(){
    var saved=readWishlist();
    document.querySelectorAll('[data-wishlist-count]').forEach(function(count){count.textContent=saved.length;count.dataset.count=String(saved.length);});
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(button){button.classList.toggle('active',saved.length>0);});
    document.querySelectorAll('.product-card').forEach(function(card){
      var button=card.querySelector('.wish-button');
      if(button) button.classList.toggle('active',saved.indexOf(card.dataset.handle)>-1);
    });
  }
  document.querySelectorAll('.wish-button').forEach(function(button){
    button.addEventListener('click',function(event){
      event.preventDefault();event.stopPropagation();
      var card=button.closest('.product-card'); if(!card) return;
      var saved=readWishlist(), handle=card.dataset.handle, index=saved.indexOf(handle);
      if(index>-1){saved.splice(index,1);notify('Removed from wishlist');}else{saved.push(handle);notify('Saved to wishlist');}
      saveWishlist(saved);renderWishlist();
    });
  });
  document.querySelectorAll('[data-wishlist-toggle]').forEach(function(button){
    button.addEventListener('click',function(){
      var saved=readWishlist();
      document.querySelectorAll('.product-card').forEach(function(card){card.style.display=saved.length&&saved.indexOf(card.dataset.handle)<0?'none':'';});
      var shop=document.getElementById('shop'); if(shop) shop.scrollIntoView({behavior:'smooth'});
      notify(saved.length?saved.length+' saved item'+(saved.length===1?'':'s'):'Your wishlist is empty — tap a heart to save items');
    });
  });
  renderWishlist();
})();


/* Clear wishlist view + universal store back button */
(function(){
  var storageKey='lumonest-wishlist';
  function savedItems(){try{return JSON.parse(localStorage.getItem(storageKey)||'[]');}catch(e){return [];}}
  function ensureBanner(){
    var banner=document.querySelector('[data-wishlist-view-banner]');
    if(banner) return banner;
    var shop=document.getElementById('shop'); if(!shop) return null;
    banner=document.createElement('section');
    banner.className='wishlist-view-banner'; banner.setAttribute('data-wishlist-view-banner',''); banner.hidden=true;
    banner.innerHTML='<div><p class="eyebrow">SAVED FOR LATER</p><h2>Your Wishlist</h2><p data-wishlist-view-copy></p></div><button type="button" data-wishlist-exit>Show all products</button>';
    shop.parentNode.insertBefore(banner,shop);
    banner.querySelector('[data-wishlist-exit]').addEventListener('click',function(){
      document.body.classList.remove('wishlist-mode'); banner.hidden=true;
      document.querySelectorAll('.product-card').forEach(function(card){card.style.display='';});
      var shopEl=document.getElementById('shop'); if(shopEl) shopEl.scrollIntoView({behavior:'smooth'});
    });
    return banner;
  }
  function showWishlist(){
    var saved=savedItems(), banner=ensureBanner();
    document.body.classList.add('wishlist-mode');
    document.querySelectorAll('.product-card').forEach(function(card){card.style.display=saved.indexOf(card.dataset.handle)>-1?'':'none';});
    if(banner){banner.hidden=false;var copy=banner.querySelector('[data-wishlist-view-copy]');if(copy) copy.textContent=saved.length?saved.length+' product'+(saved.length===1?'':'s')+' saved — solid hearts are in your wishlist.':'Your wishlist is empty. Tap any heart to save a product.';}
  }
  document.querySelectorAll('[data-wishlist-toggle]').forEach(function(button){button.addEventListener('click',function(){setTimeout(showWishlist,0);});});
  document.querySelectorAll('.wish-button').forEach(function(button){button.addEventListener('click',function(){setTimeout(function(){
    button.setAttribute('aria-pressed',button.classList.contains('active')?'true':'false');
    if(document.body.classList.contains('wishlist-mode')){if(!button.classList.contains('active')){var card=button.closest('.product-card');if(card)card.style.display='none';}showWishlist();}
  },0);});});
  document.querySelectorAll('.wish-button').forEach(function(button){button.setAttribute('aria-pressed',button.classList.contains('active')?'true':'false');});
})();


/* Buy Now checks out only the selected product, not existing bag items. */
document.addEventListener('click', async function (event) {
  var button = event.target.closest('[data-modal-buy]');
  if (!button) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  var addButton = document.querySelector('[data-modal-add]');
  var variantId = addButton && addButton.dataset.variant;
  if (!variantId) return;
  button.disabled = true;
  button.textContent = 'Opening checkout…';
  try {
    var cleared = await fetch('/cart/clear.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'} });
    if (!cleared.ok) throw new Error('clear failed');
    var added = await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[{id:Number(variantId),quantity:1}]}) });
    if (!added.ok) throw new Error('add failed');
    window.location.href = '/checkout';
  } catch (error) {
    button.disabled = false;
    button.textContent = 'Buy now';
  }
}, true);


/* My Orders OTP guidance */
document.addEventListener('click', function (event) {
  var myOrdersLink = event.target.closest('.orders-button');
  if (!myOrdersLink) return;
  event.preventDefault();
  window.location.hash = 'login-help';
}, true);


/* ln-checkout-loader-recovery-v1 */
(function () {
  'use strict';

  function clearRouteLoading() {
    if (document.body) document.body.classList.remove('ln-route-loading');
  }

  function isSensitiveNavigation(element) {
    if (!element) return false;
    var href = element.getAttribute('href') || '';
    var text = ((element.textContent || '') + ' ' + (element.getAttribute('aria-label') || '')).toLowerCase();
    return href === '/account' ||
      href.indexOf('/checkout') !== -1 ||
      /buy now|checkout|secure checkout/.test(text) ||
      !!element.closest('.shopify-payment-button');
  }

  function recoverSoon() {
    Promise.resolve().then(clearRouteLoading);
    window.setTimeout(clearRouteLoading, 0);
    window.setTimeout(clearRouteLoading, 800);
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('a,button') : null;
    if (isSensitiveNavigation(target)) recoverSoon();
  }, true);

  document.addEventListener('submit', function (event) {
    if (event.target && event.target.closest && event.target.closest('.shopify-payment-button, form[action*="checkout"]')) {
      recoverSoon();
    }
  }, true);

  window.addEventListener('pageshow', clearRouteLoading);
  window.addEventListener('load', clearRouteLoading);
  window.addEventListener('popstate', clearRouteLoading);
  window.addEventListener('focus', clearRouteLoading);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) clearRouteLoading();
  });

  clearRouteLoading();
})();
